// Constants
export const afiliado_documentos = () => {
    return {
        afiliado_documentos: {
            id: {
                namepath: ['afiliacion_documentos'],
                type: "number",
                label: "id",
                placeholder: "",
                description: "",
                validate: "",
                datatype: {
                    type: "input",
                    disabled: true,
                    predeterminate: "",
                }
            },
            id_datos_afiliado: {
                type: "text",
                label: "datos afiliado",
                placeholder: "",
                namepath: ['afiliacion_inclusiones'],
                description: "",
                validate: "",
                datatype: {
                    type: "select",
                    disabled: false,
                    predeterminate: "",
                    list: "datos_razon",
                    label: 'name'
                }
            },
            id_info_afiliacion: {
                type: "text",
                label: "Afiliación id",
                placeholder: "",
                namepath: ['afiliacion_inclusiones'],
                description: "",
                validate: "",
                datatype: {
                    type: "input",
                    disabled: true,
                    predeterminate: "",
                }
            },
            id_list_users: {
                type: "text",
                label: "Usuario",
                placeholder: "",
                namepath: ['afiliacion_inclusiones'],
                description: "",
                validate: "required",
                datatype: {
                    type: "select",
                    disabled: false,
                    predeterminate: '',
                    list: "list_users",
                    label: 'name',
                }
            },
            name: {
                type: "text",
                label: "Nombre Documento",
                placeholder: "",
                namepath: ['afiliacion_documentos'],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: "",
                }
            },
            archivo: {
                namepath: ['afiliacion_documentos'],
                type: 'text',
                label: 'Seleccionar documento',
                placeholder: '',
                description: 'documento',
                validate: '',
                datatype: {
                    type: 'file',
                    disabled: false,
                    predeterminate: [],
                }
            },
            nota_delete: {
                type: "text",
                label: "Nota",
                placeholder: "",
                namepath: [''],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null
                }
            },
        },
    }
}